// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"217":"8728ebf3","219":"664b671b","238":"25bf52a5","274":"4ebf0cfb","348":"96059074","356":"27e94957","600":"8797773e","759":"30334d0c","985":"e20c0046"}[chunkId] + ".chunk.js";
};